<span *ngIf="total > 99" class="badge-num">{{moreThan99Str}}</span>
<span *ngIf="total > 0 && total < 100" class="badge-num">{{ total }}</span>
